import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const REFERRAL_KEY = 'rubby_referral_code';

export function useReferralTracking() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (ref) {
      sessionStorage.setItem(REFERRAL_KEY, ref);
    }
  }, [searchParams]);
}

export function getStoredReferralCode(): string | null {
  return sessionStorage.getItem(REFERRAL_KEY);
}

export function clearStoredReferralCode() {
  sessionStorage.removeItem(REFERRAL_KEY);
}
